export const captureSelectedYear = (year) => ({
  type: "Selected_Year",
  payload: year,
});
